export default "__VITE_ASSET__DjLilw53__"